import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import NotificationsNoneRoundedIcon from '@mui/icons-material/NotificationsNoneRounded';
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import defaultImage from "../../../assets/images/default.jpg";
import { usePermission } from "../../../hooks/usePermission";
import { permissionError } from "../../../util/Alert";
import Iconb from "../../extra/Iconb";
import Pagination from "../../extra/Pagination";
import Searching from "../../extra/Searching";
import Table from "../../extra/Table";
import ToggleSwitch from "../../extra/ToggleSwitch";
import { OPEN_DIALOGUE } from "../../store/dialogue/dialogue.type";
import { getSeller, sellerIsBlock } from "../../store/seller/seller.action";
import SellerNotification from "./SellerNotification";

// 👇 yaha add karo (imports ke baad)
const Section = ({ title, children }) => (
  <div
    style={{
      border: "1px solid #eee",
      borderRadius: 8,
      padding: 10,
      marginTop: 12,
      fontSize: 13,
      background: "#fafafa"
    }}
  >
    <div
      style={{
        fontWeight: 600,
        marginBottom: 6,
        color: "#e91e63",
        fontSize: 12
      }}
    >
      {title}
    </div>

    <div style={{ lineHeight: 1.4 }}>
      {children}
    </div>
  </div>
);


const Seller = (props) => {

  const { can } = usePermission();
  const canEdit = can("Seller", "Edit");

  const hasPermission = useSelector((state) => state.admin.admin.flag);

  const [size, setSize] = useState(10);
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [openSellerModal, setOpenSellerModal] = useState(false);
  const [selectedSeller, setSelectedSeller] = useState(null);

  const { seller, totalSeller } = useSelector((state) => state.seller);
  const { dialogue, dialogueType, dialogueData } = useSelector(
    (state) => state.dialogue
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();



  useEffect(() => {
    dispatch(getSeller(currentPage, size));
  }, [dispatch, currentPage, size]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500); // Adjust the delay time as needed

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setData(seller);
  }, [seller]);

  // // pagination
  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event), 10);
    setSize(parseInt(event), 10);
    setCurrentPage(1);
  };

  const handleClick = (sellerDetails) => {
    if (!hasPermission) return permissionError();
    props.sellerIsBlock(
      sellerDetails,
      sellerDetails.isBlock === true ? false : true
    );
  };
  const handleOpen = (id) => {
    // window.location.href = "/admin/userProfile"
    navigate("/admin/sellerProfile", {
      state: id,
    });
  };

  const handleEdit = (id) => {
    navigate("/admin/addSeller", {
      state: id,
    });
  };

  // searching

  const handleFilterData = (filteredData) => {
    if (typeof filteredData === "string") {
      setSearch(filteredData);
    } else {
      setData(filteredData);
    }
  };

  const handleOpenSellerModal = (seller) => {
    setSelectedSeller(seller);
    setOpenSellerModal(true);
  };

  const handleCloseSellerModal = () => {
    setOpenSellerModal(false);
    setSelectedSeller(null);
  };

  const mapData = [
    {
      Header: "No",
      width: "20px",
      Cell: ({ index }) =>
        <span className="text-white fw-normal">
          {(currentPage - 1) * rowsPerPage + index + 1}
        </span>,
    },
    {
      Header: "Seller",
      body: "firstName",
      Cell: ({ row }) => (
        <div className="d-flex">
          <div className="position-relative">
                <img
                  src={row?.image ? row?.image : defaultImage}
                  style={{
                    borderRadius: "10px",
                    objectFit: "cover",
                    boxSizing: "border-box",
                    cursor: "pointer",
                  }}
                  height={45}
                  width={45}
                  alt=""
                  onClick={() => handleOpenSellerModal(row)}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = defaultImage;
                  }}
                />
          </div>
          <span className="boxCenter text-start ms-3 fw-normal text-white">
            {row?.firstName + " " + row?.lastName}
          </span>
        </div>
      ),
      sorting: false,
    },

    {
      Header: "Contact",
      body: "email",
      Cell: ({ row }) => (
        <div className="">
          <p className="mb-0 text-white fw-normal">{row?.email ? row?.email : "xyz@gmail.com"}</p>
          <p className="mb-0 text-white fw-normal">{row?.mobileNumber ? row?.mobileNumber : "-"}</p>
        </div>
      ),
      sorting: false,
    },
    {
      Header: "Business Name",
      body: "businessName",
      Cell: ({ row }) => (
        <span className="mb-0 text-white fw-normal">
          {row?.businessName ? row?.businessName : "-"}
        </span>
      ),
    },
    {
      Header: "Business Tag",
      body: "businessTag",
      Cell: ({ row }) => (
        <span className="mb-0 text-white fw-normal">{row.businessTag ? row.businessTag : "-"}</span>
      ),
    },

    {
      Header: "Total Product",
      body: "totalProduct",
      Cell: ({ row }) => (
        <span
          className="mb-0 text-dark"
          style={{
            backgroundColor: "#c6e7ff",
            color: "#000",
            padding: "10px 15px",
            borderRadius: "5px",
          }}
        >
          {row.totalProduct ? row.totalProduct : 0}
        </span>
      ),
    },
    {
      Header: "Total Order",
      body: "totalOrder",
      Cell: ({ row }) => (
        <span
          className="mb-0 text-dark"
          style={{
            backgroundColor: "#c6e7ff",
            color: "#000",
            padding: "10px 15px",
            borderRadius: "5px",
          }}
        >
          {row?.totalOrder ? row?.totalOrder : 0}
        </span>
      ),
    },

    ...(canEdit ? [
      {
        Header: "Block",
        body: "isBlock",
        Cell: ({ row }) => (
          <div
            className={``}
          >
            <ToggleSwitch value={row?.isBlock} onClick={() => handleClick(row)} disabled={row?.email === "erashoptest@gmail.com" && true} />
          </div>
        ),
      }
    ] : []),

    {
      Header: "Created Date",
      body: "createdAt",
      Cell: ({ row }) => (
        <span className="text-white fw-normal">{dayjs(row.createdAt).format("DD MMM YYYY")}</span>
      ),
    },
    {
      Header: "Notification",
      body: "",
      Cell: ({ row }) => (
        <Iconb
          newClass={`themeFont boxCenter infobtn userBtn fs-5`}
          btnIcon={<NotificationsNoneRoundedIcon sx={{ color: '#737272' }} />}
          style={{
            borderRadius: "50px",
            margin: "auto",
            height: "45px",
            width: "45px",
            color: "#160d98",

            padding: "0px"
          }}
          onClick={() => {
            dispatch({
              type: OPEN_DIALOGUE,
              payload: { data: row, type: "SellerNotification" },
            });
          }}
        />
      ),
    },

    ...(canEdit ? [
      {
        Header: "Edit",
        body: "",
        Cell: ({ row }) => (
          <Iconb
            newClass={`themeFont boxCenter infobtn userBtn fs-5`}
            btnIcon={<CreateOutlinedIcon sx={{ color: '#737272' }} />}
            style={{
              borderRadius: "50px",
              margin: "auto",
              height: "45px",
              width: "45px",
              color: "#160d98",


            }}
            isImage={true}
            onClick={() => handleEdit(row)}

          />


        ),
      }
    ] : []),


    {
      Header: "Info",
      body: "",
      Cell: ({ row }) => (
        <Iconb
          newClass={`themeFont boxCenter infobtn userBtn fs-5`}
          btnIcon={<InfoOutlined sx={{ color: '#737272' }} />}
          style={{
            borderRadius: "50px",
            margin: "auto",
            height: "45px",
            width: "45px",
            color: "#160d98",

            padding: "0px"
          }}
          isImage={true}
          isDeleted={true}
          onClick={() => handleOpen(row?._id)}

        />
      ),
    },


    // add more columns as needed
  ];
  return (

    <>
      <div className="mainSellerTable">

        <Modal open={openSellerModal} onClose={handleCloseSellerModal}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "70%",
              maxWidth: "720px",
              bgcolor: "#fff",
              borderRadius: "14px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
              p: 2,
              maxHeight: "85vh",
              overflowY: "auto"
            }}
          >

            {/* HEADER */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <h3 style={{ margin: 0, fontSize: 18 }}>Seller Details</h3>

              <div
                onClick={handleCloseSellerModal}
                style={{
                  cursor: "pointer",
                  border: "1.5px solid #f06292",
                  borderRadius: "50%",
                  height: 24,
                  width: 24,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#f06292",
                  fontSize: 13,
                  fontWeight: "bold"
                }}
              >
                ✕
              </div>
            </div>

            {selectedSeller && (
              <>
                {/* PROFILE */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                    border: "1px solid #eee",
                    padding: 12,
                    borderRadius: 10,
                    marginTop: 15
                  }}
                >
                  <img
                    src={selectedSeller.image || defaultImage}
                    height={55}
                    width={55}
                    style={{ borderRadius: "50%", objectFit: "cover" }}
                  />

                  <div>
                    <h4 style={{ margin: 0, fontSize: 15 }}>
                      {selectedSeller.firstName} {selectedSeller.lastName}
                    </h4>

                    <span
                      style={{
                        background: "#e91e63",
                        color: "#fff",
                        padding: "3px 12px",
                        borderRadius: 20,
                        fontSize: 10,
                        marginTop: 4,
                        display: "inline-block"
                      }}
                    >
                      Seller
                    </span>
                  </div>
                </div>

                {/* STATS */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(4,1fr)",
                    gap: 10,
                    marginTop: 15
                  }}
                >
                  {[
                    ["Followers", selectedSeller.followers],
                    ["Following", selectedSeller.following],
                    ["Products", selectedSeller.totalProduct],
                    ["Orders", selectedSeller.totalOrder]
                  ].map(([label, value]) => (
                    <div
                      key={label}
                      style={{
                        border: "1px solid #eee",
                        borderRadius: 10,
                        padding: 12,
                        textAlign: "center",
                        background: "#fafafa",
                        fontSize: 12
                      }}
                    >
                      <div style={{ fontWeight: 600 }}>{label}</div>
                      <div style={{ fontSize: 15 }}>{value ?? 0}</div>
                    </div>
                  ))}
                </div>

                {/* GRID INFO */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 12,
                    marginTop: 15
                  }}
                >

                  <Section title="Personal Info">
                    Email: {selectedSeller.email}<br />
                    Mobile: {selectedSeller.mobileNumber}<br />
                    Gender: {selectedSeller.gender || "N/A"}
                  </Section>

                  <Section title="Address">
                    {selectedSeller.address?.address}<br />
                    City: {selectedSeller.address?.city}<br />
                    State: {selectedSeller.address?.state}<br />
                    Country: {selectedSeller.address?.country}
                  </Section>

                  <Section title="Bank">
                    Bank: {selectedSeller.bankDetails?.bankName}<br />
                    Acc: {selectedSeller.bankDetails?.accountNumber}<br />
                    IFSC: {selectedSeller.bankDetails?.IFSCCode}
                  </Section>

                  <Section title="Business">
                    Name: {selectedSeller.businessName}<br />
                    Tag: {selectedSeller.businessTag || "N/A"}
                  </Section>

                </div>
              </>
            )}
          </Box>
        </Modal>



        <div className="sellerTable">

          <div className="col-12 headname">Seller </div>

          <div className="sellerMain">
            <div className="tableMain mt-2">
              <div className="sellerHeader primeHeader">
                <div className="row">
                  <div className="col-2">


                    {dialogue && dialogueType === "SellerNotification" && (
                      <SellerNotification />
                    )}
                  </div>
                  <div className="col-10 d-flex justify-content-end">
                    <Searching
                      type={`client`}
                      data={seller}
                      setData={setData}
                      column={data}
                      onFilterData={handleFilterData}
                      serverSearching={handleFilterData}
                      button={true}
                      setSearchValue={setSearch}
                      searchValue={search}
                      placeholder="Search by seller, contact, business name or tag"
                    />
                  </div>
                </div>
              </div>
              <Table
                data={data}
                mapData={mapData}
                serverPerPage={rowsPerPage}
                serverPage={page}
                type={"server"}
                loading={loading}
                shimmer={true}
              />
              <Pagination
                component="div"
                count={totalSeller}
                type={"server"}
                onPageChange={handleChangePage}
                serverPerPage={rowsPerPage}
                totalData={totalSeller}
                serverPage={currentPage}
                setCurrentPage={setCurrentPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          </div>
          <div className="sellerFooter primeFooter"></div>
        </div>
      </div>
    </>
  );
};

export default connect(null, { getSeller, sellerIsBlock })(Seller);
// export default Seller;
